// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-version {
  width: 346px;
  height: 480px;
  position: absolute;
  left: calc(50% - 173px);
  top: calc(50% - 240px);
  overflow: hidden;
  opacity: 1;
  z-index: 20;
  border-radius: 5px;
  animation: popup 0.1s ease-in-out 0s 1;
}
.update-log-out-button {
  min-width: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 20px;
  cursor: pointer;
  position: absolute;
  right: 12px;
}
.new-version-title {
  font-size: 18px;
  font-weight: 500;
  line-height: 15px;
  opacity: 1;
  margin: 20px 0px 10px;
  text-align: center;
  width: 346px;
}
.new-version-open {
  margin-top: -5px;
  min-width: 80px;
  padding: 0px 10px;
  height: 36px;
  opacity: 1;
  border-radius: 25px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  transition: 0.1s;
  z-index: 50;
  font-size: 15px;
}
.new-version-copy {
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  line-height: 35px;
  text-align: center;
  margin-left: 148px;
  display: inline-block;
}
.update-dialog-new-title,
.update-dialog-fix-title {
  font-size: 15px;
  font-weight: bold;
  line-height: 15px;
  opacity: 1;
  margin-top: 10px;
  margin-left: 20px;
}
.update-dialog-list {
  font-size: 15px;
  line-height: 18px;
  opacity: 1;
  margin: 12px;
}
.update-dialog-new-container,
.update-dialog-fix-container {
  margin: 20px 10px;
}
.update-dialog-info {
  margin-top: 10px;
  height: 330px;
  overflow-y: scroll;
  width: 346px;
}
.update-dialog-illustration {
  width: 200px;
  position: absolute;
  bottom: 0px;
  right: 0px;
  z-index: 20;
}
.update-dialog-container-button {
  width: 75px;
  height: 32px;
  opacity: 1;
  line-height: 32px;
  text-align: center;
  margin: 12px 130px;
  position: absolute;
  cursor: pointer;
  z-index: 25;
}
.update-dialog-url {
  width: 200px;
  font-size: 13px;
  position: absolute;
  bottom: 6px;
  left: 10px;
  -webkit-user-select: text;
          user-select: text;
  z-index: 30;
  line-height: 16px;
}
.update-dialog-subtitle {
  font-size: 13px;
  margin: 5px;
  text-align: center;
}
.update-info-text {
  text-align: center;
  font-size: 15px;
  opacity: 0.6;
  margin-top: 15px;
}
.new-version-skip {
  min-width: 80px;
  padding: 0px 10px;
  height: 25px;
  opacity: 1;
  border-radius: 25px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  z-index: 50;
  transition: 0.1s;
  font-size: 13px;
}
.new-version-badge {
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
  color: white;
  margin-left: 10px;
  height: 20px;
  line-height: 20px;
  border-radius: 5px;
  padding: 0px 5px;
  position: relative;
  top: -2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/updateDialog/updateInfo.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;EAEE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX","sourcesContent":[".new-version {\n  width: 346px;\n  height: 480px;\n  position: absolute;\n  left: calc(50% - 173px);\n  top: calc(50% - 240px);\n  overflow: hidden;\n  opacity: 1;\n  z-index: 20;\n  border-radius: 5px;\n  animation: popup 0.1s ease-in-out 0s 1;\n}\n.update-log-out-button {\n  min-width: 70px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 20px;\n  cursor: pointer;\n  position: absolute;\n  right: 12px;\n}\n.new-version-title {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 15px;\n  opacity: 1;\n  margin: 20px 0px 10px;\n  text-align: center;\n  width: 346px;\n}\n.new-version-open {\n  margin-top: -5px;\n  min-width: 80px;\n  padding: 0px 10px;\n  height: 36px;\n  opacity: 1;\n  border-radius: 25px;\n  line-height: 36px;\n  text-align: center;\n  cursor: pointer;\n  transition: 0.1s;\n  z-index: 50;\n  font-size: 15px;\n}\n.new-version-copy {\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 35px;\n  text-align: center;\n  margin-left: 148px;\n  display: inline-block;\n}\n.update-dialog-new-title,\n.update-dialog-fix-title {\n  font-size: 15px;\n  font-weight: bold;\n  line-height: 15px;\n  opacity: 1;\n  margin-top: 10px;\n  margin-left: 20px;\n}\n.update-dialog-list {\n  font-size: 15px;\n  line-height: 18px;\n  opacity: 1;\n  margin: 12px;\n}\n.update-dialog-new-container,\n.update-dialog-fix-container {\n  margin: 20px 10px;\n}\n.update-dialog-info {\n  margin-top: 10px;\n  height: 330px;\n  overflow-y: scroll;\n  width: 346px;\n}\n.update-dialog-illustration {\n  width: 200px;\n  position: absolute;\n  bottom: 0px;\n  right: 0px;\n  z-index: 20;\n}\n.update-dialog-container-button {\n  width: 75px;\n  height: 32px;\n  opacity: 1;\n  line-height: 32px;\n  text-align: center;\n  margin: 12px 130px;\n  position: absolute;\n  cursor: pointer;\n  z-index: 25;\n}\n.update-dialog-url {\n  width: 200px;\n  font-size: 13px;\n  position: absolute;\n  bottom: 6px;\n  left: 10px;\n  user-select: text;\n  z-index: 30;\n  line-height: 16px;\n}\n.update-dialog-subtitle {\n  font-size: 13px;\n  margin: 5px;\n  text-align: center;\n}\n.update-info-text {\n  text-align: center;\n  font-size: 15px;\n  opacity: 0.6;\n  margin-top: 15px;\n}\n.new-version-skip {\n  min-width: 80px;\n  padding: 0px 10px;\n  height: 25px;\n  opacity: 1;\n  border-radius: 25px;\n  line-height: 32px;\n  text-align: center;\n  cursor: pointer;\n  z-index: 50;\n  transition: 0.1s;\n  font-size: 13px;\n}\n.new-version-badge {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: bold;\n  color: white;\n  margin-left: 10px;\n  height: 20px;\n  line-height: 20px;\n  border-radius: 5px;\n  padding: 0px 5px;\n  position: relative;\n  top: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
